import { keyframes } from 'styled-components';

export const moveUp = keyframes`
	0% { transform: translate3d(0, 100%, 0); }
	100% { transform: translate3d(0, 0, 0); }
`;
